import React from "react";
import { FiList, FiSliders } from "react-icons/fi";
import { useTranslation } from "../context/TranslationContext";
import { ADVANCED_SEARCH_MODE } from "../helpers/advancedSearchHelper";

// "Busca simples | Busca avançada" pill switch (same look as the portal switch).
const SearchModeToggle = ({ mode, onChange }) => {
  const { t } = useTranslation();
  const options = [
    { value: "simple", Icon: FiList },
    { value: ADVANCED_SEARCH_MODE, Icon: FiSliders },
  ];
  const selectedIndex = mode === ADVANCED_SEARCH_MODE ? 1 : 0;
  return (
    <div
      className="portal-switch search-mode-toggle"
      role="radiogroup"
      aria-label={t("advancedSearchForm.modeLabel")}
      style={{ "--portal-switch-index": selectedIndex }}
    >
      <span className="portal-switch-highlight" aria-hidden="true" />
      {options.map(({ value, Icon }, index) => {
        const checked = index === selectedIndex;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={checked}
            className={`portal-switch-option${checked ? " is-selected" : ""}`}
            onClick={() => !checked && onChange(value)}
          >
            <Icon className="portal-switch-icon" aria-hidden="true" focusable="false" />
            <span className="portal-switch-label">{t(`advancedSearchForm.modes.${value}`)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SearchModeToggle;
